var exports = {
  "P": "xdbfd91f1--ab43ae--adaptive-header",
};

module.exports = exports;
